import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-10 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">热门话题</h2>
          <p className="text-sm text-foreground-500 mb-8">漫画读者正在热烈讨论的话题与标签</p>

          <div className="flex flex-wrap gap-2 md:gap-3">
            {topicItems.map((item, i) => (
              <a
                key={i}
                href="#topics"
                className="group flex items-center gap-2 px-4 py-2.5 bg-background-50 border border-background-200/70 rounded-full hover:border-primary-300 hover:bg-background-100 transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-500 transition-colors">
                  #{item.tag}
                </span>
                <span className="text-xs text-foreground-400 bg-background-100 px-2 py-0.5 rounded-full">
                  {item.count}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}